class EMICalculator {
  constructor(modalHostElement, options = {}) {
    this.modalHostContainer = modalHostElement;
    this.productCode = options.productCode || "";
    this.productPrice = parseFloat(options.productPrice) || 0;
    this.priceInPaisa = Math.round(this.productPrice * 100);
    this.merchantId = 326895;
    this.merchantAccessCode = "0682eeff-876e-44e2-b9ab-ecf813cd5644";
    this.apiUrl = "https://cors.vleafy.com/https://pinepg.in/api/v2/emi/calculator";
    this.emiData = null;
    this.loading = false;
    this.error = null;
    this.activeTab = "No Cost_EMI";
    this.groupedEmiData = { "No Cost_EMI": [], "Low Cost_EMI": [], "Standard EMI": [] };
    this.bankLogos = {
          'SBI': 'https://1000logos.net/wp-content/uploads/2018/03/SBI-Logo.png',
          'ICICI': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3Yfl3u_FGS0L-sfnzW1kBeUqtwZnmAoztlg&s',
          'ICICI_Debit': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3Yfl3u_FGS0L-sfnzW1kBeUqtwZnmAoztlg&s',
          'HDFC': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRXgiz41maa34mpQoVYhRyZ8wk8XOMZfHvIrA&s',
		  'HDFC_Bank_Debit_Card': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRXgiz41maa34mpQoVYhRyZ8wk8XOMZfHvIrA&s',
          'AXIS': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRYllHUy4iQ3SNGhAQy-sXg9qX3QR5WJUo-sV6ZDl4clzI6Q8OzkK_2OJS596piI4CIzho',
          'AXIS CREDIT CARD': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRYllHUy4iQ3SNGhAQy-sXg9qX3QR5WJUo-sV6ZDl4clzI6Q8OzkK_2OJS596piI4CIzho',
          'KOTAK': 'https://e7.pngegg.com/pngimages/20/41/png-clipart-kotak-mahindra-bank-logo-thumbnail-bank-logos.png',
          'YES': 'https://www.vhv.rs/dpng/d/438-4386875_yes-bank-logo-png-transparent-png.png',
          'RBL_Bank': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRTgS5UaLYIuJWZV9rbs9RM9yCdKRcJYkS_nA&s',
          'HSBC': 'https://www.pngarts.com/files/1/HSBC-Logo-Transparent-Image.png',
          'STANDARD_CHARTERED_BANK': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR45uCMOZoXBmTzG6X-ZvKd2T0tILB2m2TPWQ&s',
          'Indusind_Bank': 'https://www.ipoplatform.com/storage/logos/pXADmF53IWEISlda4VtBv3j9GEips8do5lktlec2.png',
          'IDFC_First_Bank': 'https://s3-symbol-logo.tradingview.com/idfc-first-bank--600.png',
          'FEDERAL': 'https://s3-symbol-logo.tradingview.com/fed-bank--600.png',
          'BOB_Card': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRL_r1Pk-pAt1fS9eh7JT1_hfsz3lm61swEaw&s',
          'BOB Card CREDIT CARD': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRL_r1Pk-pAt1fS9eh7JT1_hfsz3lm61swEaw&s',
          'AU_SMALL_FINANCE_BANK_LTD': 'https://companieslogo.com/img/orig/AUBANK.NS-1d52c885.png?t=1720244490',
          'AU SMALL FINANCE BANK LTD CREDIT CARD': 'https://companieslogo.com/img/orig/AUBANK.NS-1d52c885.png?t=1720244490',
          'OneCard': 'https://media.licdn.com/dms/image/v2/C4E0BAQHHqxTnGRCPJA/company-logo_200_200/company-logo_200_200/0/1641884670569/onecard_app_logo?e=2147483647&v=beta&t=n-Gewm13XbFnxcxyEg2Kj5mBmeQ35oGR5d6Onts2RsE',
          'Punjab National Bank': 'https://companieslogo.com/img/orig/PNB.NS-f0a1e3ee.png?t=1720244493',
          'INDIAN_OVERSEAS_BANK': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTj68VOp2hw-1bDxb5i2QAUhQc6VZCAFCzL_Q&s',
          'AMEX': 'https://www.americanexpress.com/content/dam/amex/us/merchant/supplies-uplift/product/images/img-WEBLOGO1-01.jpg'
        };


    this.bankDispNames = {
          'SBI': 'SBI',
          'ICICI': 'ICICI',
          'ICICI_Debit': 'ICICI Debit',
          'HDFC': 'HDFC',
		  'HDFC_Bank_Debit_Card': 'HDFC Debit Card',
          'AXIS': 'Axis',
          'AXIS CREDIT CARD': 'Axis Credit Card',
          'KOTAK': 'Kotak',
          'YES': 'YES Bank',
          'RBL_Bank': 'RBL',
          'HSBC': 'HSBC',
          'STANDARD_CHARTERED_BANK': 'Standard Chartered',
          'Indusind_Bank': 'IndusInd',
          'IDFC_First_Bank': 'IDFC First',
          'FEDERAL': 'Federal Bank',
          'BOB_Card': 'BOB Debit Card',
          'BOB Card CREDIT CARD': 'BOB Credit Card',
          'AU_SMALL_FINANCE_BANK_LTD': 'AU Small Finance Bank',
          'AU SMALL FINANCE BANK LTD CREDIT CARD': 'AU Small Finance Credit Card',
          'OneCard': 'OneCard',
          'Punjab National Bank': 'Punjab National Bank',
          'INDIAN_OVERSEAS_BANK': 'Indian Overseas Bank',
          'AMEX': 'AMEX'
        };
		
  }

  async fetchAndProcessData() {
    this.loading = true;
    if (!this.productCode || this.priceInPaisa <= 0) {
      this.loading = false;
      throw new Error("Missing product details.");
    }
    const resp = await fetch(this.apiUrl, {
      method: "POST", 
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        merchant_data: {
          merchant_id: this.merchantId,
          merchant_access_code: this.merchantAccessCode
        },
        payment_data: { amount_in_paisa: this.priceInPaisa },
        product_details: [{
          product_code: this.productCode,
          product_amount: this.priceInPaisa
        }]
      })
    });
    if (!resp.ok) throw new Error(`API Error (${resp.status})`);
    this.emiData = await resp.json();
    this.processEmiDataInternal();
    this.loading = false;
    return this.findLowestEMI();
  }

  processEmiDataInternal() {
    this.groupedEmiData = { "No Cost_EMI": [], "Low Cost_EMI": [], "Standard EMI": [] };
    if (!this.emiData?.issuer) return;
    this.emiData.issuer.forEach(bank => {
      const bn = bank.issuer_name;
      const logo = this.getBankLogo(bn);
      let noCost = [], lowCost = [], std = [];
      (bank.list_emi_tenure || [])
        .sort((a,b)=> +a.tenure_in_month - +b.tenure_in_month)
        .forEach(t => {
          if (t.monthly_installment <= 0) return;
          const pd = t.offer_scheme.product_details[0];
          const plan = {
            tenure: t.tenure_in_month,
            monthlyInstallment: t.monthly_installment/100,
            interestAmount: t.interest_pay_to_bank/100,
            interestRate: t.bank_interest_rate/10000,
            totalAmount: (t.monthly_installment/100)*+t.tenure_in_month,
            discount: t.total_offerred_discount_cashback_amount/100
          };
          if (pd.subvention_type === 1) noCost.push(plan);
          else if (pd.subvention_type === 2) lowCost.push(plan);
          else std.push(plan);
        });
      if (noCost.length)  this.groupedEmiData["No Cost_EMI"].push({ bankName: this.bankDispNames[bn], bankLogo: logo, emiPlans: noCost });
      if (lowCost.length) this.groupedEmiData["Low Cost_EMI"].push({ bankName: this.bankDispNames[bn], bankLogo: logo, emiPlans: lowCost });
      if (std.length)     this.groupedEmiData["Standard EMI"].push({ bankName: this.bankDispNames[bn], bankLogo: logo, emiPlans: std });
    });
  }

  findLowestEMI() {
    let low = Infinity;
    Object.values(this.groupedEmiData).flat().forEach(b => {
      b.emiPlans.forEach(p => {
        if (p.monthlyInstallment > 0 && p.monthlyInstallment < low) low = p.monthlyInstallment;
      });
    });
    return low === Infinity ? null : low;
  }

  getBankLogo(name) {
    const fb = `https://via.placeholder.com/36/E0E0E0/757575?text=${name[0]||'?'}`;
    return this.bankLogos[name] || this.bankLogos[name.toUpperCase()] || fb;
  }

  formatCurrency(x) {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency', currency: 'INR',
      minimumFractionDigits: 2, maximumFractionDigits: 2
    }).format(x);
  }

  renderAndShowModal() {
    
    const header = document.getElementById('shopify-section-header');
    if (header) header.style.zIndex = '0';

    const tempClass = document.getElementsByClassName('card__collapsible-button');
    for (let i = 0; i < tempClass.length; i++) {
      tempClass[i].style.display = 'none';
    }

    const flixHotspots = document.getElementById('flix_hotspots');
    if (flixHotspots) {
      flixHotspots.setAttribute('style', 'display: none !important;');
    }

    const plusButtons = document.querySelectorAll('.plus-button');
    plusButtons.forEach(btn => btn.style.display = 'none');

    const collapsibleContent = document.querySelectorAll('.card__collapsible-content');
    collapsibleContent.forEach(el => el.style.display = 'none');

    const cardClass = document.getElementsByClassName('card');
    for (let i = 0; i < cardClass.length; i++) {
      cardClass[i].style.border = 'none';
    }
    
    if (!this.modalElement) this._renderModalDOM();
    this.modalElement.classList.add('darl-cust-modal--open');
    document.body.style.overflow = 'hidden';
    this.switchTab(this.activeTab);
  }

  _renderModalDOM() {
    this.modalHostContainer.innerHTML = `
      <div class="darl-cust-modal">
        <div class="darl-cust-modal-container">
          <div class="darl-cust-header">
            <span class="darl-cust-retail">DARLING RETAIL</span>
            <button type="button" class="darl-cust-close">&times;</button>
          </div>
          <div class="darl-cust-order-info">
            <label>Product Price</label>
            <div class="darl-cust-price">${this.formatCurrency(this.productPrice)}</div>
          </div>
          <ul class="darl-cust-tabs-nav">
            <li class="darl-cust-tab" data-tab="No Cost_EMI">No Cost EMI</li>
            <li class="darl-cust-tab" data-tab="Low Cost_EMI">Low Cost EMI</li>
            <li class="darl-cust-tab" data-tab="Standard EMI">Standard EMI</li>
          </ul>
          <div class="darl-cust-tab-content"></div>
          <ul class="darl-cust-footer">
            <li>Select payment through Pinelabs when checking out.</li>
            <li>Some No-Cost/Low-Cost EMI or Cashback Schemes can be availed if the eligible products are the ONLY item in your cart.</li>
            <li>The cashback will be credited at the beginning or the end of the EMI Tenure.</li>
            <li>If a card is eligible for an upfront discount for EMI, the interest amount will be waived off.</li>
          </ul>
        </div>
      </div>`;
    this.modalElement = this.modalHostContainer.querySelector('.darl-cust-modal');
    this.modalElement.querySelector('.darl-cust-close')
      .addEventListener('click', () => this._close());
    this.modalElement.querySelectorAll('.darl-cust-tab')
      .forEach(tab => tab.addEventListener('click', e => this.switchTab(e.target.dataset.tab)));
  }

  _close() {
    const header = document.getElementById('shopify-section-header');
    if (header) header.style.zIndex = '5';

     const tempClass = document.getElementsByClassName('card__collapsible-button');
    for (let i = 0; i < tempClass.length; i++) {
      tempClass[i].style.display = 'flex';
    }

    const cardClass = document.getElementsByClassName('card');
    for (let i = 0; i < cardClass.length; i++) {
      cardClass[i].style.border = '1px solid #e1e3e4';
    }

    const flixHotspots = document.getElementById('flix_hotspots');
    if (flixHotspots) {
      flixHotspots.style.setProperty('display', 'block', 'important');
    }

    const plusButtons = document.querySelectorAll('.plus-button');
    plusButtons.forEach(btn => btn.style.display = 'block');

    const collapsibleContent = document.querySelectorAll('.card__collapsible-content');
    collapsibleContent.forEach(el => el.style.display = 'block');
    
    this.modalElement.classList.remove('darl-cust-modal--open');
    document.body.style.overflow = '';
  }

  switchTab(tabKey) {
    this.activeTab = tabKey;
    this.modalElement.querySelectorAll('.darl-cust-tab')
      .forEach(t => t.classList.toggle('active', t.dataset.tab === tabKey));
    const content = this.modalElement.querySelector('.darl-cust-tab-content');
    const banks = this.groupedEmiData[tabKey] || [];
    if (!banks.length) {
      content.innerHTML = `<p style="padding:20px;text-align:center;color:#666;">
        No ${tabKey.replace('_',' ')} plans available.</p>`;
      return;
    }
    content.innerHTML = banks.map((b,i) => `
      <div class="darl-cust-offer-list" data-idx="${i}">
        <div class="darl-cust-logo"><img src="${b.bankLogo}" alt="${b.bankName}"></div>
        <div class="darl-cust-bank">
          <h6>${b.bankName}</h6>
          <!--<label>${tabKey.replace('_',' ')}</label>-->
        </div>
      </div>
      <div class="darl-cust-detail-list"></div>
    `).join('');
    this.modalElement.querySelectorAll('.darl-cust-offer-list').forEach(el => {
      el.addEventListener('click', () => {
        const idx = +el.dataset.idx;
        const bank = banks[idx];
        const details = el.nextElementSibling;
        if (details.innerHTML) {
          el.classList.remove('open'); details.innerHTML = '';
        } else {
          el.classList.add('open');
          details.innerHTML = bank.emiPlans.map((p,j)=>`
            <div class="darl-cust-option-item">
             
              <div class="darl-cust-amount">
                <h6><b>${this.formatCurrency(p.monthlyInstallment)}</b> for ${p.tenure} ${+p.tenure>1?'months':'month'}&emsp;&emsp;&emsp;<span class='mobile-only-break'><br></span><b>Total: ${this.formatCurrency(p.monthlyInstallment*p.tenure)}</b> </h6>
                <div class="darl-cust-rate">@${p.interestRate.toFixed(2)}% p.a.&emsp;Total Interest: ${this.formatCurrency(p.interestAmount)}&emsp; <span class='mobile-only-break'><br></span>Cashback: ${this.formatCurrency(p.discount)}</div>
                <div class="darl-cust-note">Standard interest rates apply</div>
              </div>
            </div>
          `).join('');
        }
      });
    });
  }
}

// —— Bootstrap logic —— 
document.addEventListener('DOMContentLoaded', () => {

   
  const anchor = document.getElementById('emiModalWrapperStandalone');
  const info   = document.getElementById('lowestEmiInfoStandalone');
  if (!anchor || !info) return;

  console.log('anchor.dataset =', anchor && anchor.dataset);

  // listen for variant changes if dropdown exists
  const select = document.querySelector('select[name="id"]');
  const runCalc = async (sku, price) => {
    const host = anchor;
    const calc = new EMICalculator(host, { productCode: sku, productPrice: price });
    try {
      const low = await calc.fetchAndProcessData();
      info.style.display = 'block';
      info.innerHTML = low !== null
        ? `EMI starting from ${calc.formatCurrency(low)}/month. <a href="#" id="viewAllPlansLinkStandalone">View all plans</a>`
        : `No EMI plans found. <a href="#" id="viewAllPlansLinkStandalone">Details</a>`;
      document.getElementById('viewAllPlansLinkStandalone')
        .addEventListener('click', e => {
          e.preventDefault();
          calc.renderAndShowModal();
        });
    } catch(e) {
      console.error('EMI error', e);
    }
  };

  // multi-variant: on change
  if (select) {
    select.addEventListener('change', () => {

      const newSku   = select.selectedOptions[0].getAttribute('data-sku');
      const newPrice = select.selectedOptions[0].value;
      
      anchor.dataset.productCode  = newSku;
      anchor.dataset.productPrice = newPrice;
      
      info.style.display = 'none';
      info.innerHTML = '';
      runCalc(newSku, newPrice);
    });
  }
 
  // always auto-run once (covers single-variant & initial state)
  runCalc(anchor.dataset.productCode, +anchor.dataset.productPrice);

});

